import {
  HelpfulLink as HelpfulLinkDto,
  HelpfulLinkOutput as HelpfulLinkOutputDto,
} from '@electricjs/core_entity-client';
import { http, HttpResponse, delay } from 'msw';

import { buildMockHelpfulLinks } from '@/mocks/data/helpfulLinksData';

// In-memory store so create/edit/delete survive refetches until page reload.
let helpfulLinks = buildMockHelpfulLinks();

const successOutput: HelpfulLinkOutputDto = { result: 'success' };

export const helpfulLinksHandlers = [
  http.get('*/v1/organizations/:organizationId/helpful_links', async () => {
    await delay();
    return HttpResponse.json(helpfulLinks, { status: 200 });
  }),

  http.post(
    '*/v1/organizations/:organizationId/helpful_links',
    async ({ request }) => {
      const body = (await request.json()) as HelpfulLinkDto;
      helpfulLinks = [
        ...helpfulLinks,
        { ...body, link_id: `helpful-link-${crypto.randomUUID()}` },
      ];

      await delay();
      return HttpResponse.json(successOutput, { status: 201 });
    }
  ),

  http.put(
    '*/v1/organizations/:organizationId/helpful_links/:linkId',
    async ({ params, request }) => {
      const body = (await request.json()) as HelpfulLinkDto;
      const exists = helpfulLinks.some(link => link.link_id === params.linkId);
      helpfulLinks = helpfulLinks.map(link =>
        link.link_id === params.linkId
          ? { ...body, link_id: link.link_id }
          : link
      );

      await delay();
      return exists
        ? HttpResponse.json(successOutput, { status: 200 })
        : new HttpResponse(null, { status: 404 });
    }
  ),

  http.delete(
    '*/v1/organizations/:organizationId/helpful_links/:linkId',
    async ({ params }) => {
      const exists = helpfulLinks.some(link => link.link_id === params.linkId);
      helpfulLinks = helpfulLinks.filter(
        link => link.link_id !== params.linkId
      );

      await delay();
      return exists
        ? HttpResponse.json(successOutput, { status: 200 })
        : new HttpResponse(null, { status: 404 });
    }
  ),
];
